(function () {
    'use strict';

    angular
        .module('moothaCanonical', ['ngAnimate', 'ui.router', 'ngMap', 'ui.router.menus', 'monospaced.mousewheel']);
})();

(function() {
  'use strict';

  angular
    .module('moothaCanonical')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('moothaCanonical')
        .service('dataService', Service);

    /** @ngInject */
    function Service($state, $rootScope) {
        // For change scope
        $rootScope.nextState = function () {
            $state.go($state.current = $state.get()[$state.current.params.count + 1]);
        }
        $rootScope.prevState = function () {
            $state.go($state.current = $state.get()[$state.current.params.count - 1]);
        }
        $rootScope.lastState = function () {
            $state.go($state.current = $state.get()[4]);
        }
        $rootScope.firstState = function () {
            $state.go($state.current = $state.get()[1]);
        }

        // For mousewheel function
        this.build = function (name, delta) {
            var o = '';

            if (delta > 0) {
                o = delta;
            } else if (delta < 0) {
                o = delta;
            }
            return o;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('moothaCanonical')
        .directive('onKeydown', Directive);

    /** @ngInject */
    function Directive($rootScope, $state) {

        // Change scope when keydown
        return function (scope, element) {
            element.bind("keydown", function (event) {
                var page = $state.current.params.count;
                if ((event.keyCode === 38 || event.keyCode === 37 || event.keyCode === 13 || event.keyCode === 8) && page != 0) {
                    if (page == 1) {
                        $rootScope.lastState();
                    } else {
                        $rootScope.prevState();
                    }
                }
                if ((event.keyCode === 40 || event.keyCode === 39) && page != 5) {
                    $rootScope.nextState();
                }
                if ((page == 4 && event.keyCode === 40 || event.keyCode === 39) || (event.keyCode === 36 || event.keyCode === 27)) {
                    $rootScope.firstState();
                }
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('moothaCanonical')
        .controller('TempController', TempController);


    /** @ngInject */

    function TempController($state, $rootScope, dataService, $window) {
        var vm = this;

        // var OSName="Unknown OS";
        var brw = "Unknown brw";
        // if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
        // if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
        // if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
        // if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

        if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) brw="Opera";
        if(navigator.userAgent.indexOf("Safari") !=-1) brw="Safari";
        if(navigator.userAgent.indexOf("Chrome") !=-1 ) brw="Chrome";
        if(navigator.userAgent.indexOf("Firefox") !=-1 ) brw="Firefox";
        if((navigator.userAgent.indexOf("MSIE") !=-1 ) || (!!document.documentMode == true )) brw="IE > 10";// eslint-disable-line

        var wheeling;
        // Change scope when scrolling
        vm.scroller = function (event, delta ) {
            var msg = dataService.build('scroller', delta);
            var page = $state.current.params.count;
            var cont = angular.element('.page_container');
            var scrollEl = cont[0].scrollHeight - cont[0].scrollTop === cont[0].clientHeight;

            function hamScroll() {
                if (!wheeling && delta == -1 && page != 4) {
                    $rootScope.nextState();

                } else if (!wheeling && delta == 1 && page != 0) {
                    if (page == 1) {
                        $rootScope.lastState();
                    } else {
                        $rootScope.prevState();
                    }
                } else if (!wheeling && delta == -1 && page == 4) {
                    $rootScope.firstState();
                }


                // setTimeout need for current work scroll, $timeout not current
                if (brw == 'Chrome') {
                    clearTimeout(wheeling);
                    wheeling = setTimeout(function () {// eslint-disable-line
                        wheeling = undefined;
                    }, 400);
                }
                if (brw == 'Firefox') {
                    clearTimeout(wheeling);
                    wheeling = setTimeout(function () {// eslint-disable-line
                        wheeling = undefined;
                    }, 200);
                }
                if (brw == 'Safari') {
                    clearTimeout(wheeling);
                    wheeling = setTimeout(function () {// eslint-disable-line
                        wheeling = undefined;
                    }, 50);
                }
                if (brw != 'Safari' && brw != 'Chrome' && brw != 'Firefox') {
                    clearTimeout(wheeling);
                    wheeling = setTimeout(function () {// eslint-disable-line
                        wheeling = undefined;
                    }, 100);
                }

            }
            if (msg !== '') {
                if (cont[0].clientHeight >= $window.innerHeight - 220) {
                    if (cont[0].clientHeight >= $window.innerHeight - 220 && delta >= 1) {
                        hamScroll();
                    }
                    if (scrollEl == true) {
                        hamScroll();
                    }
                } else {
                    hamScroll();
                }
            }
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('moothaCanonical')
        .controller('MapController', MapController);


    /** @ngInject */
    function MapController(NgMap) {
        var vm = this;
        var customPoint;
        var width = angular.element('body').clientWidth;
        vm.positions1 = [
            {
                pos: [
                    50.488882,
                    30.491149
                ],
                name: 1,
                title: 'Kyiv, Ukraine',
                'class': 'place-1',
                email: 'ua@mootha.biz',
                tel: '+357 97 79-28-56'
            },
            // {
            //     pos: [
            //         52.374172,
            //         4.889686
            //     ],
            //     name: 2,
            //     title: 'Amsterdam, Netherlands',
            //     'class': 'place-2',
            //     email: 'nl@mootha.biz',
            //     tel: '+31 6 1567-20-91'
            // },
            {
                pos: [
                    34.707543,
                    33.020411
                ],
                name: 3,
                title: 'Limassol, Cyprus',
                address: '157, Archibishop Makarios Ave., \r\n office on the 1st floor, Limassol, 3026',
                'class': 'selected place-3',
                email: 'cy@mootha.biz',
                tel: '+357 97 79-28-56'
            }
        ];
        if (width <= 1440 && width > 440 && width > 740) {
            customPoint = [
                {
                    pos: [
                        66.059393,
                        -33.580339
                    ],
                    'class': 'none'
                },
                {
                    pos: [
                        66.227695,
                        56.532604
                    ],
                    'class': 'none'
                }
            ];
        } else if (width <= 440 && width <= 840) {
            customPoint = [
                {
                    pos: [
                        79.059393,
                        4.889686
                    ],
                    'class': 'none'
                },
                {
                    pos: [
                        79.227695,
                        30.491149
                    ],
                    'class': 'none'
                }
            ];
        } else {
            customPoint = [
                {
                    pos: [
                        54.059393,
                        -33.580339
                    ],
                    'class': 'none'
                },
                {
                    pos: [
                        54.227695,
                        56.532604
                    ],
                    'class': 'none'
                }
            ];
        }
        vm.positions1 = vm.positions1.concat(customPoint);
        vm.setPositions = function (pos) {
            vm.positions = angular.copy(pos);
            vm.selectedMarker = vm.positions[1];
        };
        vm.setStyle = [
            {
                'featureType': 'administrative.country',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {'color': '#ffffff'},
                    {'weight': 1}
                ]
            },
            {
                'featureType': 'road',
                'stylers': [{'visibility': 'off'}]
            },
            {
                'featureType': 'landscape.natural',
                'stylers': [
                    {'visibility': 'on'},
                    {'color': '#fafafa'}
                ]
            },
            {
                'featureType': 'poi',
                'stylers': [{'visibility': 'off'}]
            },
            {
                'featureType': 'administrative.country',
                'elementType': 'geometry.stroke',
                'stylers': [{'color': '#e4e4e4'}]
            },
            {
                'featureType': 'water',
                'elementType': 'labels',
                'stylers': [
                    {'visibility': 'off'},
                    {'color': '#e4e4e4'}
                ]
            },
            {
                'featureType': 'administrative.country',
                'elementType': 'labels.text.fill',
                'stylers': [{'color': '#9a9a9a'}]
            },
            {
                'featureType': 'administrative.country',
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {'color': '#ffffff'},
                    {'weight': 1}
                ]
            },
            {
                'featureType': 'water',
                'stylers': [{'color': '#e4e4e4'}]
            },
            {
                'featureType': 'administrative.province',
                'stylers': [{'visibility': 'off'}]
            },
            {
                'featureType': 'administrative.locality',
                'stylers': [{'visibility': 'off'}]
            }
        ];
        NgMap.getMap().then(function (map) {
            vm.map = map;
        });


        vm.changeClass = function (event, index) {

            vm.selectedMarker = vm.positions[index];
            var all = angular.element('.custom-marker');
            for (var i = 0; i < all.length; i++) {
                all[i].classList.remove('selected');
                // It's called not from ng-click but from on-click in ng-map custom-marker so we use 'this'
                /*eslint-disable */
                this.classList.add('selected');
                /*eslint-disable */
            }
        };
        vm.setPositions(vm.positions1);
    }
})();

(function() {
  'use strict';

  angular
    .module('moothaCanonical')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
    'use strict';

    angular
        .module('moothaCanonical')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(true);
        $locationProvider.hashPrefix('!');
        $stateProvider
            .state('home', {
                url: '/',
                templateUrl: 'app/temp/home.html',
                menu: 'Home',
                params: {
                    count: 1
                }
            })
            .state('solutions', {
                url: '/solutions',
                templateUrl: 'app/temp/solutions.html',
                menu: 'solutions',
                params: {
                    count: 2
                }
            })
            .state('careers', {
                url: '/careers',
                templateUrl: 'app/temp/careers.html',
                menu: 'careers',
                params: {
                    count: 3
                }
            })
            .state('contacts', {
                url: '/contacts',
                templateUrl: 'app/temp/contacts.html',
                controller: 'MapController',
                controllerAs: 'vm',
                menu: 'contacts',
                params: {
                    count: 4
                }
            })
            .state('gift', {
                url: '/gift',
                templateUrl: 'app/temp/gift.html',
                controller: 'MapController',
                controllerAs: 'vm'
            })
            .state('none', {
                params: {
                    count: 5
                }
            });

        $urlRouterProvider.otherwise('/home');

    }


})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('moothaCanonical')
    .constant('moment', moment);

})();

angular.module("moothaCanonical").run(["$templateCache", function($templateCache) {$templateCache.put("app/temp/careers.html","<section class=page3><div class=page_container><h1>Join the Mootha Team<br>and Do a Better Web</h1><p><!-- DO NOT DELETE THIS: text if open position--> Our young and fast growing team constantly recruits new staff.<br>Here are some of our open positions:<!-- DO NOT DELETE THIS: text if no position--><!--Thank you for your interest in job opportunities with Mootha.--><!--<br>--><!--Unfortunately we have no open positions this time.--><!--<br>--><!--Your CV data will be stored and secured in our database--><!--<br>--><!--for possible future job opportunities as well.--><!--<br>--><!--Should we see vacancies which fit your qualifications--><!--<br>--><!--and career goals we shall contact you immediately.--></p><ul class=list><!--<li>--><!--<h4>Middle Python Developer</h4>--><!--<p>--><!--Full Time / Kyiv / Experience from 3 years.--><!--</p>--><!--<a href=\"mailto: job@mootha.biz\">Mail us</a>--><!--</li>--><!--<li>--><!--<h4>Business Analyst / Technical Writer</h4>--><!--<p>--><!--Full Time / Experience from 2 years.--><!--</p>--><!--<a href=\"mailto: job@mootha.biz\">Mail us</a>--><!--</li>--><li><h4>RoR Developer</h4><p>✓ Full Time / Kyiv<br>✓ 4 years of in Ruby and Ruby on Rails stack<br>✓ Adherence to TDD, SOLID, KISS, DRY principles<br>✓ 2+ years of experience in Multi Service Application, Data and Application Integration, Web Services<br>✓ 2+ years experience managing web-based and/or SaaS application development projects<br>✓ Strong understanding of Software development and release life cycle, Agile methodologies<br>✓ Good analytical and problem-solving skills, creative problem solving<br>✓ Ability to adapt and learn quickly in a dynamic, fast-paced environment<br>✓ Excellent organizational skills including ability to prioritize tasks efficiently with high level of attention to details<br>✓ Outstanding communication, interpersonal, and relationship building skills conducive to team development<br>✓ Strong sense of ownership, follow-through, and orientation towards results</p><a href=\"mailto: nika.arkatova@mootha.biz\">Mail us</a><p><br><br><br><br><br><br><br><br><br><br><br><br><br><br></p></li></ul></div></section>");
$templateCache.put("app/temp/contacts.html","<section class=page4><div class=custom-maps><ng-map id=foo zoom-to-include-markers=auto fit=true scrollwheel=false default-style=false pan-control=false map-type-control=false zoom-control=false draggable=false street-view-control=false styles={{vm.setStyle}}><custom-marker ng-repeat=\"p in vm.positions track by $index\" position={{p.pos}} on-click=\"vm.changeClass(event, $index);\"><div class=\"marker-cust {{p.class}}\">{{p.title}}</div></custom-marker></ng-map></div><div class=page_container><h1>Get in Touch</h1><br><span class=style-p ng-bind=vm.selectedMarker.address></span> <span class=style-p ng-bind=vm.selectedMarker.email></span> <span class=style-p ng-bind=vm.selectedMarker.tel></span><br></div></section>");
$templateCache.put("app/temp/gift.html","<section class=page2><div class=page_container><h1>Gift</h1><p>You can use certificate card to get services from Mootha or <a href=https://advancedhosters.com/en/ target=_blank>AdvancedHosting</a><br>(dedicated servers, VDS/VPS, CDN, VoD, Domain Registrations, AnycastDNS).<br>To redeem your card please email <a href=mailto:yuriy.sivolotskiy@mootha.biz>yuriy.sivolotskiy@mootha.biz</a><br>or call +357 97 79-28-56</p><div class=mootha-logo><img src=./../../assets/images/transparent-ratio-conserver.png class=responsive-image></div></div></section>");
$templateCache.put("app/temp/home.html","<section class=page1><div class=page_container><h1>Better Together</h1><p>Get the power of the best software for the hosting solutions<br>to take your business to the next level.</p><div class=mootha-logo><img src=./../../assets/images/transparent-ratio-conserver.png class=responsive-image></div></div></section>");
$templateCache.put("app/temp/solutions.html","<section class=page2><div class=page_container><h1>Reliable Solutions</h1><p>Get the utmost of the best customer tailored solutions<br>for your business.</p><ul class=\"list ico-li\"><li class=ico-1><h4>Manage Sites</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li><li class=ico-7><h4>Hosting Management</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li><li class=ico-5><h4>Content Delivery</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li><li class=ico-2><h4>Video Streaming</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li><li class=ico-4><h4>Customer Management</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li><li class=ico-6><h4>Resource Planning</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li><li class=ico-3><h4>Project Management</h4><p><!--Having full visibility of assets you have deployed across the globe can be challenging.--></p></li></ul></div></section>");
$templateCache.put("app/components/navbar/navbar.html","<nav><ul menus=menuItems><li ng-repeat=\"menu in menuItems | orderBy:\'-priority\'\" ui-sref-active=active><a ui-sref={{menu.state.name}}>{{menu.name}}</a></li></ul></nav>");}]);